// extracted by mini-css-extract-plugin
export default {"wrapper":"MainMenu_wrapper__IWrpQ","item":"MainMenu_item__h82oo","link":"MainMenu_link__l8l-8","arrow":"MainMenu_arrow__7NrUf"};